/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { Popover } from '@mui/material';
import VerticalDots from '../img/verticalDots.svg';
import MenuPopup from '../../menuPopup/MenuPopup';
import './ColumnVehicleConfigurator.css';

const CustomPresetName = ({ row }) => (
    <div>
        <b>{row.presetName}</b>
    </div>
);

const CustomDateCreated = ({ row }) => {
    const {
        dateCreated,
    } = row;

    return (
        <div>
            {dateCreated !== null ? (
                <>
                    <div className="table-date-text">{dateCreated.date}</div>
                    <div>
                        <div
                          className="table-time-text"
                          data-tag="allowRowEvents"
                          style={{
                            color: 'grey',
                            overflow: 'hidden',
                            whiteSpace: 'normal',
                            textOverflow: 'ellipsis',
                          }}
                        >
                            {dateCreated.time}
                        </div>
                    </div>
                </>
            ) : (
                <></>
            )}
        </div>
    );
};

const CustomMenuButton = (assets) => {
    const { row, rowIndex } = assets;
    const [anchorEl, setAnchorEl] = useState(null);
    const [assetRow, setAssetRow] = useState();
    const handleClick = (event) => {
        setAssetRow(row);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAssetRow();
        setAnchorEl(null);
    };

    const handleDelete = () => {
        row?.onDelete?.(row);
        handleClose();
    };

    return (
        <div>
            <div className="assets-button" id={rowIndex} aria-hidden="true" onClick={handleClick}>
                <div className="assets-menu">
                    <img loading="lazy" src={VerticalDots} alt="MenuIcon" />
                </div>
            </div>
            <Popover
              id={rowIndex}
              sx={{
                boxShadow: 2,
                borderRadius: 2,
            }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
                <MenuPopup page="adminVehicleConfigurator" assetDetails={assetRow} deleteButton={handleDelete} />
            </Popover>
        </div>
    );
};

export const VehicleConfiguratorColumn = [
    {
        name: 'Vehicle Preset',
        selector: (row) => row.presetName,
        sortable: true,
        cell: (row) => <CustomPresetName row={row} />,
    },
    {
        name: 'Date Created',
        selector: (row) => row?.dateCreated?.date,
        sortable: true,
        cell: (row) => <CustomDateCreated row={row} />,
    },
    {
        cell: (row, rowIndex) => (
            <CustomMenuButton row={row} rowIndex={rowIndex} />
        ),
        allowOverflow: true,
        button: true,
        width: '48px',
    },
];
